export default "__VITE_ASSET__oin8a2nS__"